module.exports = __webpack_public_path__ + "img/mlcisocert_52022.e37583c6.jpg";